Auth = require 'db/auth'
trigger = require 'lib/util/event/trigger'
window.getAuthorization = ->
  type: 'cookie', token: Auth.myToken()



// WEBPACK FOOTER //
// ./app/scripts/init/globals.coffee